import { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    Box,
    Button,
    Typography,
} from '@mui/material';


const ServiceModal = () => {

    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState(null)

    const handleClosed = () => {
        setOpen(false);
        setMessage(null)
    }

    useEffect(() => {
    const fetchPaymentMethods = async () => {
        try {
            const response = await fetch( process.env.REACT_APP_API_URL + '/service/getModal', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            setOpen( data.open )
            setMessage( data.message )

        } catch (error) {
            console.error('Failed to fetch payment methods:', error);
        }
    };

    fetchPaymentMethods();
}, []);
   
   
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClosed}

            >
                <DialogContent
                    sx={{
                        maxWidth: '400px'
                    }}
                >
                    <Typography variant="body1" align="center" mt={1}>
                        {message}
                    </Typography>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mt={2}
                    >
                        <Button onClick={handleClosed}>
                            Закрыть
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )

}

export default ServiceModal;